import type { EditorState } from '../types';
/** Sync is an editing relationship, not permission to change per-track lock/magnet settings. */
export const setLinkingEnabled = (
  state: EditorState,
  enabled: boolean,
): EditorState =>
  state.isLinkingEnabled === enabled
    ? state
    : { ...state, isLinkingEnabled: enabled };
export const toggleLinking = (state: EditorState): EditorState =>
  setLinkingEnabled(state, !state.isLinkingEnabled);
